import { render, staticRenderFns } from "./DeleteGroupModal.vue?vue&type=template&id=5008d610&scoped=true"
import script from "./DeleteGroupModal.vue?vue&type=script&lang=js"
export * from "./DeleteGroupModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteGroupModal.vue?vue&type=style&index=0&id=5008d610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008d610",
  null
  
)

export default component.exports